export const BREAKPOINT_MOBILE = 576;
export const BREAKPOINT_LARGE = 1625;

// Padding values
export const MOBILE_PADDING = 24;
export const VIEWPORT_PADDING_PERCENTAGE = 0.1;

// Card spacing
export const CARD_GAP = 8;

// Scroll behavior
export const SCROLL_DEBOUNCE_DELAY = 150;
export const SCROLL_STATE_UPDATE_DELAY = 100;

// Animation
export const TRANSITION_DURATION = 300;
